define("resources/tools", function(){
return {
    "Bunsen_Burner": {
        name: "Bunsen_Burner",
        icon: "styles/icons/bunsenBurner.svg",
        template: "app/scripts/templates/bunsenBurner.ejs",
        toolClass: "bunsen",
        contactPoint: [18, 0]
    },
    "Scale": {
        name: "Scale",
        icon: "styles/icons/scale.svg",
        template: "app/scripts/templates/scale.ejs",
        toolClass: "scale",
        contactPoint: [80, 35]
    }
}
});
